module.exports = __webpack_public_path__ + "media/state-press-2_800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-2_800.jpg
// module id = 42
// module chunks = 0